import { DropdownInput } from '../../../baseInputs/DropdownInput';

export const TextDecorationInput = ({ value, onChange }: { value?: string; onChange: (newValue?: string) => void }) => {
  return <DropdownInput label='Decoration' value={value} onChange={(newValue) => onChange(newValue?.toString())} canBeCleared={false} options={
    [
      { value: 'underline', label: 'Underline' },
      { value: 'overline', label: 'Overline' },
      {
        value: 'line-through', label: 'Line-through'
      }]}
  />;
};
